import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        list: '=',
        classifiers: '<',
        defaultFilter: '<',
        apgView: '<',
        toggleFilter: '<'
    },
    template: `
        <form ng-if="vm.toggleFilter" ng-submit="vm.applyFilter()">
            <div class="row">
                <label class="label">{{ 'filter.Name' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.filter.name" type="text" class="form-control">
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Department' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.departmentSelect.options"
                        selected-model="vm.FilterService.departmentSelect.models"
                        extra-settings="vm.FilterService.departmentSelect.settings"
                        events="vm.FilterService.departmentSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Role' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.roleSelect.options"
                        selected-model="vm.FilterService.roleSelect.models"
                        extra-settings="vm.FilterService.roleSelect.settings"
                        events="vm.FilterService.roleSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Level' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.levelSelect.options"
                        selected-model="vm.FilterService.levelSelect.models"
                        extra-settings="vm.FilterService.levelSelect.settings"
                        events="vm.FilterService.levelSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled() && !vm.apgView" class="row separated">
                <label class="label">{{ 'filter.Also display optional targets' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.drlCourseOptionalTargets">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div ng-if="vm.apgView" class="row">
                <span class="label">{{ 'filter.Include employees in automated planning group' | translate }}</span>
                <div class="items">
                    <label class="switch01 mt1em">
                        <input type="checkbox" ng-model="vm.filter.includeStartedApg">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="items">
                    <a class="btn main small btn-indented" ng-click="vm.applyFilter()">{{ 'general.Search' | translate }}</a>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor (lodash, UserService, FilterService, TokenService, SiteService,
                 CLASSIFIER_ENUM, USER_STATUS_ENUM, ROLE_CODE_ENUM, ROLE_PRIVILEGE_ENUM) {
        this.lodash = lodash;
        this.UserService = UserService;
        this.FilterService = FilterService;
        this.TokenService = TokenService;
        this.SiteService = SiteService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.FilterService.init(this.classifiers);

        this.initDefaultFilter();

        this.filter = angular.copy(this.defaultFilter);
        this.toggleFilter = false;

        this.filterTranslations = this.FilterService.getTranslations();
        this.applyFilter();
    }

    initDefaultFilter () {
        const siteIds = this.SiteService.getSitesByPrivileges(
            [
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE,
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE
            ],
            false
        ).map((site) => site.id);

        this.defaultFilter = {
            privilegesCheck: false,
            drlCourseId: this.course.id,
            siteIds: siteIds.length ? siteIds : [-1],
            startedApgCourseId: this.course.id,
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            statuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED]
        };
    }

    applyFilter () {
        this.filter.departmentIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter.roleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter.levelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        if (this.filter.drlCourseOptionalTargets === false) {
            delete this.filter.drlCourseOptionalTargets;
        }

        this.list.fetch({ expand: 'drlsWithValue,courseUsers' }, this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/employee/targets/filter/index.js